<script>
import axios from "axios";
import {toast} from "vue3-toastify";
import modalKkMixin from "../conversation-club/modal-kk-mixin.js";
import vSelect from "vue-select";
import _ from "lodash";


export default {
  name: "vyuka-form",
  components: {vSelect},
  props: ['lesson', 'btyp'],
  mixins: [modalKkMixin],

  data() {
    return {
      options:[],
      showModalFlag: false,
      isLoading: false,
      selected_student:{},
      lectors: [],
      organizations: [],
      preferredTimeOptions: {
        'weekday_morning': 'Weekday morning',
        'weekday_afternoon': 'Weekday afternoon',
        'weekday_evening': 'Weekday evening',
        'weekend': 'Weekend'
      }
    };
  },
  computed: {
    // Vrací pole všech vybraných student IDs (z existujících studentů)
    selectedStudentIds() {
      const ids = [];
      
      // Z vybraných existujících studentů v dropdownech
      Object.values(this.selected_student).forEach(student => {
        if (student && student.id && !String(student.id).startsWith('new_')) {
          ids.push(student.id);
        }
      });
      
      return ids;
    },
    
    // Vrací pole všech vybraných emailů (case-insensitive)
    selectedStudentEmails() {
      const emails = [];
      
      // Z vybraných existujících studentů
      Object.values(this.selected_student).forEach(student => {
        if (student && student.email) {
          emails.push(student.email.toLowerCase().trim());
        }
      });
      
      // Z nových záznamů (nově vytvářených studentů)
      if (this.lesson.students) {
        this.lesson.students.forEach(student => {
          if (student.is_new_record && student.email) {
            emails.push(student.email.toLowerCase().trim());
          }
        });
      }
      
      return emails;
    },
    
    // Maximální počet studentů podle typu lekce
    maxStudents() {
      if (this.lesson.lesson_type === 'one_to_one') return 1;
      if (this.lesson.lesson_type === 'two_students') return 2;
      if (this.lesson.lesson_type === 'group') return Infinity;
      return 0; // pokud není vybrán typ
    },
    
    // Lze přidat další studenty?
    canAddMoreStudents() {
      // Pokud není vybrán typ lekce, nelze přidávat
      if (!this.lesson.lesson_type) return false;
      
      // Pokud ještě nejsou žádní studenti, lze přidávat
      if (!this.lesson.students || this.lesson.students.length === 0) return true;
      
      // Kontrola limitu
      return this.lesson.students.length < this.maxStudents;
    },
    
    // Popisek zobrazující stav přidaných studentů
    studentCountLabel() {
      if (!this.lesson.lesson_type) return '';
      const current = this.lesson.students?.length || 0;
      
      if (this.lesson.lesson_type === 'group') {
        return `Přidáno: ${current} ${current === 1 ? 'student' : (current < 5 ? 'studenti' : 'studentů')}`;
      }
      
      return `Přidáno: ${current} / ${this.maxStudents}`;
    },
    
    // Lze změnit typ lekce?
    canChangeLessonType() {
      // Pokud nejsou žádní studenti, lze měnit typ vždy
      if (!this.lesson.students || this.lesson.students.length === 0) {
        return true;
      }
      
      // Pro B2C - typ je vždy zamčený na one_to_one
      if (this.btyp === 'b2c') {
        return false;
      }
      
      // Pokud jsou studenti, povolit změnu typu jen pokud počet odpovídá některému z možných typů
      const currentCount = this.lesson.students.length;
      
      // Můžeme přepnout na:
      // - one_to_one pokud máme právě 1 studenta
      // - two_students pokud máme právě 2 studenty
      // - group pokud máme 1+ studentů (vždy)
      
      // Takže zamknout jen pokud máme 3+ studenty a současný typ NENÍ group
      if (currentCount >= 3 && this.lesson.lesson_type !== 'group') {
        return false;
      }
      
      // Pro 1-2 studenty povolit přepínání mezi všemi typy
      return true;
    },
    
    // Dynamická varovná hláška pro zamčený typ lekce
    lessonTypeLockedMessage() {
      if (this.canChangeLessonType) return '';
      
      const currentCount = this.lesson.students?.length || 0;
      
      if (currentCount >= 3) {
        return `Máte přidáno ${currentCount} studentů. Pro změnu typu odstraňte některé, aby počet odpovídal: 1 student (one-to-one) nebo 2 studenti (párová lekce).`;
      }
      
      return 'Typ nelze změnit v této situaci.';
    }
  },
  watch: {
    lesson: {
      handler(newLesson, oldLesson) {
        if (newLesson) {
          // Detekce změny lekce (editace jiné lekce)
          const isLessonChange = oldLesson && oldLesson.id !== newLesson.id;
          
          if (newLesson.students) {
            // Reset pokud je to jiná lekce, jinak zachovat existující výběry
            const selected = isLessonChange ? {} : { ...this.selected_student };
            
            newLesson.students.forEach(student => {
              // Nastavit pouze pokud ještě není vybraný student pro tento slot
              if (!selected[student.id]) {
                // Pro existující studenty použít jejich data, pro nové sloty null
                selected[student.id] = student.is_new ? null : student;
              }
            });
            this.selected_student = selected;
          } else {
            this.selected_student = {};
          }
          // Nastaví hodnotu pro pole s kreditem na aktuální celkový kredit
          if (this.lesson.change_credit == undefined) this.lesson.change_credit = newLesson.credit;
          
          // Convert preferred_time string to array for multi-select
          // Only initialize if preferred_times doesn't exist yet
          if (!newLesson.preferred_times) {
            if (newLesson.preferred_time) {
              const times = typeof newLesson.preferred_time === 'string' 
                ? newLesson.preferred_time.split(',').map(t => t.trim())
                : [];
              newLesson.preferred_times = times;
            } else {
              newLesson.preferred_times = [];
            }
          }
          
          // B2C je vždy credit_based
          if (this.btyp === 'b2c' && !this.lesson.accounting_type) {
            this.lesson.accounting_type = 'credit_based';
          }
          
          // Default na flexible pokud není nastaveno
          if (!this.lesson.accounting_type) {
            this.lesson.accounting_type = 'flexible';
          }
        } else {
          this.selected_student = {};
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.loadLectors()
    this.loadOrganizations()
  },



  methods: {
    hideModal() {
      this.showM = false;
      // Vyčistit selected_student při zavření modalu pro zabránění cross-contamination
      this.selected_student = {};
    },
    removeStudent(index) {
      const studentToRemove = this.lesson.students[index];
      if (studentToRemove) {
        delete this.selected_student[studentToRemove.id];
      }
      this.lesson.students.splice(index, 1);
    },
    addNewStudentSlot() {
      // Kontrola zda je vybrán typ lekce
      if (!this.lesson.lesson_type) {
        toast.warning("Nejprve vyberte typ lekce.");
        return;
      }
      
      // Kontrola limitu
      if (!this.canAddMoreStudents) {
        const typeName = this.lesson.lesson_type === 'one_to_one' ? 'one-to-one' : 
                         this.lesson.lesson_type === 'two_students' ? 'párovou lekci' : 'skupinovou lekci';
        toast.warning(`Pro ${typeName} můžete přidat max. ${this.maxStudents} ${this.maxStudents === 1 ? 'studenta' : 'studenty'}.`);
        return;
      }
      
      if (!this.lesson.students) {
        this.lesson.students = [];
      }
      const tempId = `new_record_${Date.now()}`;
      this.lesson.students.push({ id: tempId, is_new_record: true, email: '', name: '', surname: '' });
    },
    addStudentSlot() {
      // Kontrola zda je vybrán typ lekce
      if (!this.lesson.lesson_type) {
        toast.warning("Nejprve vyberte typ lekce.");
        return;
      }
      
      // Kontrola limitu
      if (!this.canAddMoreStudents) {
        const typeName = this.lesson.lesson_type === 'one_to_one' ? 'one-to-one' : 
                         this.lesson.lesson_type === 'two_students' ? 'párovou lekci' : 'skupinovou lekci';
        toast.warning(`Pro ${typeName} můžete přidat max. ${this.maxStudents} ${this.maxStudents === 1 ? 'studenta' : 'studenty'}.`);
        return;
      }
      
      if (!this.lesson.students) {
        this.lesson.students = [];
      }
      // Použijeme dočasné ID pro klíč a v-model
      const tempId = `new_${Date.now()}`;
      this.lesson.students.push({ id: tempId, is_new: true });
      this.selected_student[tempId] = null;
    },
    onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },

    search: _.debounce((loading, search, vm) => {
      fetch(
          `/ll/students/all?q=${encodeURIComponent(search)}`
      ).then(res => {
        res.json().then(json => {
          // Automaticky filtrovat již vybrané studenty z výsledků
          vm.options = json.items.filter(option => 
            !vm.selectedStudentIds.includes(option.id)
          );
          loading(false);
        });
      });
    }, 350),
    
    togglePreferredTime(timeKey) {
      if (!this.lesson.preferred_times) {
        this.lesson.preferred_times = [];
      }
      
      const index = this.lesson.preferred_times.indexOf(timeKey);
      if (index > -1) {
        this.lesson.preferred_times.splice(index, 1);
      } else {
        this.lesson.preferred_times.push(timeKey);
      }
    },

    clearAllPreferredTimes() {
      if (this.lesson.preferred_times) {
        this.lesson.preferred_times = [];
      }
    },


    async loadLectors() {
      const r2 = await axios.get('/conversation-clubs/lectors.json', {
        params: {
          //level: this.lesson.level
          per: 100
        }
      })
      this.lectors = r2.data.items
    },
    async loadOrganizations() {
      const response = await axios.get('/ll/companies-options.json')
      this.organizations = response.data
    },
    sendData() {
      // ============================================================
      // VALIDACE: Kontrola duplicitních studentů
      // ============================================================
      const studentIds = new Set();
      const studentEmails = new Set();
      const duplicates = [];
      
      // Projít všechny sloty studentů v lekci
      this.lesson.students.forEach((studentSlot, index) => {
        if (studentSlot.is_new_record) {
          // === NOVÝ ZÁZNAM STUDENTA (vytváří se nový student) ===
          const email = studentSlot.email?.toLowerCase().trim();
          
          if (!email) {
            duplicates.push(`Slot ${index + 1}: Email nového studenta je povinný`);
            return;
          }
          
          // Kontrola duplicity emailu mezi novými záznamy
          if (studentEmails.has(email)) {
            duplicates.push(`Student s emailem "${studentSlot.email}" je v lekci vícekrát`);
          } else {
            studentEmails.add(email);
          }
        } else {
          // === EXISTUJÍCÍ STUDENT (vybraný z dropdownu) ===
          const selectedStudent = this.selected_student[studentSlot.id];
          
          if (!selectedStudent || !selectedStudent.id) {
            duplicates.push(`Slot ${index + 1}: Vyberte studenta nebo ho odstraňte`);
            return;
          }
          
          const studentId = selectedStudent.id;
          const studentEmail = selectedStudent.email?.toLowerCase().trim();
          
          // Kontrola duplicity ID
          if (studentIds.has(studentId)) {
            duplicates.push(
              `${selectedStudent.name} ${selectedStudent.surname} (${selectedStudent.email}) je v lekci vícekrát`
            );
          } else {
            studentIds.add(studentId);
            if (studentEmail) studentEmails.add(studentEmail);
          }
        }
      });
      
      // Kontrola duplicit mezi novými záznamy a existujícími studenty
      // (pokud vytváříme nového studenta s emailem, který už je vybraný)
      this.lesson.students.forEach(studentSlot => {
        if (studentSlot.is_new_record) {
          const newEmail = studentSlot.email?.toLowerCase().trim();
          
          // Najít existujícího studenta se stejným emailem
          // OPRAVA: Vyloučit is_new_record z hledání (kontrolovat JEN existující studenty)
          const existingStudent = Object.values(this.selected_student).find(s => 
            s && !s.is_new_record && s.email?.toLowerCase().trim() === newEmail
          );
          
          if (existingStudent) {
            duplicates.push(
              `Student s emailem "${studentSlot.email}" je již vybrán jako existující student (${existingStudent.name} ${existingStudent.surname})`
            );
          }
        }
      });
      
      // Pokud byly nalezeny chyby, zobrazit a zastavit
      if (duplicates.length > 0) {
        const errorMessage = duplicates.length === 1 
          ? duplicates[0]
          : `Nelze uložit - nalezeny následující problémy:\n• ${duplicates.join('\n• ')}`;
        
        toast.error(errorMessage, {
          autoClose: 5000,
          position: 'top-center'
        });
        return;
      }
      // ============================================================
      // KONEC VALIDACE
      // ============================================================
      
      // ============================================================
      // VALIDACE: Kontrola počtu studentů podle typu lekce
      // ============================================================

      // Kontrola zda je vybrán typ lekce
      if (!this.lesson.lesson_type) {
        toast.error("Vyberte typ lekce (Types of lessons).");
        return;
      }

      // Spočítat konečný počet studentů (již máme proměnnou finalStudents později, takže validujeme lesson.students)
      const studentCountForValidation = this.lesson.students.filter(studentSlot => {
        if (studentSlot.is_new_record) {
          return studentSlot.email && studentSlot.email.trim() !== '';
        } else {
          const selectedStudent = this.selected_student[studentSlot.id];
          return selectedStudent && selectedStudent.id;
        }
      }).length;

      // Validace podle typu lekce
      if (this.lesson.lesson_type === 'one_to_one') {
        if (studentCountForValidation !== 1) {
          toast.error("Pro výuku one-to-one musí být přiřazen právě 1 student.");
          return;
        }
      }

      if (this.lesson.lesson_type === 'two_students') {
        if (studentCountForValidation !== 2) {
          toast.error("Pro párovou lekci musí být přiřazeni právě 2 studenti.");
          return;
        }
      }

      if (this.lesson.lesson_type === 'group') {
        if (studentCountForValidation < 1) {
          toast.error("Pro skupinovou lekci musí být přiřazen alespoň 1 student.");
          return;
        }
      }

      // ============================================================
      // KONEC VALIDACE POČTU STUDENTŮ
      // ============================================================
      
      // Validace pro B2B - firma je povinná
      if (this.btyp === 'b2b' && !this.lesson.organization_id) {
        toast.error("Pro B2B výuku je povinné vybrat firmu.");
        return;
      }

      const finalStudents = this.lesson.students.map(studentSlot => {
        if (studentSlot.is_new_record) {
          return studentSlot; // Nový záznam studenta
        }
        // Pro existující sloty (původní i nově přidané)
        const selectedStudent = this.selected_student[studentSlot.id];
        return selectedStudent ? { id: selectedStudent.id, email: selectedStudent.email, name: selectedStudent.name, surname: selectedStudent.surname } : null;
      }).filter(s => s !== null); // Odstraníme prázdné sloty

      // Convert preferred_times array to comma-separated string
      const preferredTimeString = this.lesson.preferred_times && this.lesson.preferred_times.length > 0
        ? this.lesson.preferred_times.join(',')
        : null;

      const lesson = { 
        ...this.lesson,
        preferred_times: this.lesson.preferred_times, // Send as array to backend
        b_type: this.btyp,
        students: finalStudents 
      };


      const url = lesson.id && !lesson.is_new_record ? `/ll/students/lessons/${lesson.id}.json` : '/ll/students/lessons.json';
      const method = lesson.id ? 'patch' : 'post';


      axios({ method, url, data: { lesson } })
          .then(response => {
            this.$emit('save-lesson', lesson);
            this.hideModal();
            toast.success("Údaje o výuce byly uloženy.");


          })
          .catch(error => {
            console.error('Došlo k chybě při ukládání lekce:', error);
            toast.error("Došlo k chybě při ukládání lekce.");
          });
    }
  }
}
</script>

<template>
  <vue-final-modal v-model="showM" classes="modal-container" content-class="modal-content-f w900">
    <div class="modal-header">
      <h5 class="modal-title">Výuka</h5>
      <button type="button" class="close" @click="hideModal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal__content">
      <!-- První řádek: Lektor, Úroveň, Jazyk, (Firma pro B2B) -->

      <div class="row">

        <div :class="btyp === 'b2b' ? 'col-md-3' : 'col-md-4'">
          <div class="form-group">
            <label>Lecturer</label>
            <select class="form-control" v-model="lesson.lector_id">
              <option></option>
              <option v-for="t in lectors" :value="t.id">{{ t.first_name }} {{ t.last_name }}</option>
            </select>
          </div>
        </div>

        <div :class="btyp === 'b2b' ? 'col-md-3' : 'col-md-4'">
          <div class="form-group">
            <label>Language level</label>
            <select class="form-control" v-model="lesson.language_level">
              <option></option>
              <option value="A1">A1</option>
              <option value="A2">A2</option>
              <option value="B1">B1</option>
              <option value="B2">B2</option>
              <option value="C1">C1</option>
              <option value="C2">C2</option>
            </select>
          </div>
        </div>

        <div :class="btyp === 'b2b' ? 'col-md-3' : 'col-md-4'">
          <div class="form-group">
            <label>Language</label>
            <select class="form-control" v-model="lesson.language_id">
              <option></option>
              <option value="1">čeština</option>
              <option value="2">angličtina</option>
              <option value="3">němčina</option>
              <option value="4">francouzština</option>
              <option value="5">španělština</option>
              <option value="6">ruština</option>
              <option value="7">italština</option>
              <option value="8">slovenština</option>
              <option value="10">polština</option>
            </select>
          </div>
        </div>

        <div class="col-md-3" v-if="btyp === 'b2b'">
          <div class="form-group">
            <label>Company <span class="text-danger">*</span></label>
            <select class="form-control" v-model="lesson.organization_id" required>
              <option :value="null">-- Vyberte firmu --</option>
              <option v-for="org in organizations" :key="org.id" :value="org.id">
                {{ org.name }}
              </option>
            </select>
          </div>
        </div>

      </div>

      <!-- Druhý řádek: Typ lekce, Název skupiny, Minuty, Preferovaný čas -->

      <div class="row">

        <div class="col-md-3">
          <div class="form-group">
            <label>Types of lessons</label>
            <select class="form-control" v-model="lesson.lesson_type" :disabled="btyp==='b2c' || !canChangeLessonType">
              <option value="">-- Vyberte typ --</option>
              <option value="one_to_one">jeden na jednoho</option>
              <option value="two_students"> párová lekce</option>
              <option value="group">skupinová lekce</option>
            </select>
            <small class="form-text text-danger" v-if="!canChangeLessonType && btyp!=='b2c'">
              <i class="fas fa-lock"></i> Typ nelze změnit, pokud jsou už přidáni studenti. Nejprve je odstraňte.
            </small>
          </div>
        </div>

        <!-- Název skupiny - shows only for párovka/group -->
        <div class="col-md-3" v-if="lesson.lesson_type === 'two_students' || lesson.lesson_type === 'group'">
          <div class="form-group">
            <label>Group name</label>
            <input 
              type="text" 
              class="form-control" 
              v-model="lesson.group_name" 
              placeholder=""
            />
            <small class="form-text text-muted">Pro snadnější identifikaci</small>
          </div>
        </div>

        <div :class="(lesson.lesson_type === 'two_students' || lesson.lesson_type === 'group') ? 'col-md-3' : 'col-md-4'">
          <div class="form-group">
            <label>How many minutes</label>
            <select class="form-control" v-model="lesson.minutes">
              <option></option>
              <option value="30">30 min (poloviční)</option>
              <option value="45">45 min</option>
              <option value="60">60 min</option>
            </select>
          </div>
        </div>

        <div :class="(lesson.lesson_type === 'two_students' || lesson.lesson_type === 'group') ? 'col-md-3' : 'col-md-4'">
          <div class="form-group">
            <label>Preferred time</label>
            <div class="preferred-time-checkboxes">
              <div 
                v-for="(label, key) in preferredTimeOptions" 
                :key="key"
                class="preferred-time-item"
              >
                <label class="mb-1 d-flex align-items-center cursor-pointer">
                  <input 
                    type="checkbox" 
                    :id="`preferred-time-${key}`" 
                    :value="key"
                    :checked="lesson.preferred_times && lesson.preferred_times.includes(key)"
                    @change="togglePreferredTime(key)"
                    class="mr-2"
                  />
                  <span>{{ label }}</span>
                </label>
              </div>
            </div>
            <small class="form-text text-muted">You can select multiple options</small>
          </div>
        </div>

      </div>

      <!-- Třetí řádek: Systém účtování -->
      <div class="row" v-if="btyp === 'b2b'">
        <div class="col-md-6">
          <div class="form-group">
            <label>Systém účtování *</label>
            <select v-model="lesson.accounting_type" class="form-control" required>
              <option value="flexible">Flexible (bez omezení)</option>
              <option value="lessons_per_month">Pevný počet lekcí za měsíc</option>
              <option value="credit_based">Kreditový systém (předplacené lekce)</option>
            </select>
            <small class="form-text text-muted">
              <strong>Flexible:</strong> Lektor může vytvářet lekce bez omezení.<br>
              <strong>Pevný počet:</strong> Maximální počet lekcí za kalendářní měsíc.<br>
              <strong>Kredit:</strong> Předplacené lekce, odečítá se kredit.
            </small>
          </div>
        </div>
      </div>

      <!-- Čtvrtý řádek: Lesson number (POUZE pro lessons_per_month) -->
      <div class="row" v-if="btyp === 'b2b' && lesson.accounting_type === 'lessons_per_month'">

        <div class="col-md-4">
          <div class="form-group">
            <label>Maximální počet lekcí za měsíc *</label>
            <input type="number" class="form-control" v-model.number="lesson.lessons_per_month" placeholder="" min="1" required/>
            <small class="form-text text-muted">Student může mít max. tento počet lekcí za kalendářní měsíc.</small>
          </div>
        </div>

      </div>

      <!-- Pátý řádek: Credit (pro B2C nebo B2B credit_based) -->
      <div class="row" v-if="btyp === 'b2c' || lesson.accounting_type === 'credit_based'">


        <div class="col-md-4">
          <div class="form-group">
            <label>{{ lesson.id ? 'Změnit kredit na' : 'Počáteční kredit' }}</label>
            <input type="number" class="form-control" v-model.number="lesson.change_credit" min="0"/>
            <small class="form-text text-muted">
              {{ lesson.id ? `Aktuální kredit: ${lesson.credit}` : 'Počet předplacených lekcí' }}
            </small>
          </div>
        </div>

      </div>


      <div v-for="(student, index) in lesson.students" :key="student.id || index"
           class="form-group">
        <label>Student/s</label>
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <div v-if="!student.is_new_record">
              <v-select 
                v-model="selected_student[student.id]" 
                @search="onSearch" 
                :filterable="false" 
                :options="options"
                :appendToBody="true"
                :selectable="option => !selectedStudentIds.includes(option.id)"
              >
                <template #option="option">
                  <div class="d-flex align-items-center" :class="{'text-muted': selectedStudentIds.includes(option.id)}">
                    <div class="flex-grow-1">
                      <div class="">{{ option.email }}</div>
                      <div class="ml-2"><b>{{ option.name }} {{ option.surname }}</b></div>
                    </div>
                    <span v-if="selectedStudentIds.includes(option.id)" class="ml-2 badge badge-warning">
                      Již vybrán
                    </span>
                  </div>
                </template>
                <template #selected-option="option">
                  <div class="d-flex">
                    <div class="">{{ option.email }}</div>
                    <div class="ml-2"><b>{{ option.name }} {{ option.surname }}</b></div>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-else>
              <div class="row">
                <div class="col-md-4"><input type="email" v-model="student.email" placeholder="Email" class="form-control"></div>
                <div class="col-md-4"><input type="text" v-model="student.name" placeholder="Jméno" class="form-control"></div>
                <div class="col-md-4"><input type="text" v-model="student.surname" placeholder="Příjmení" class="form-control"></div>
              </div>
            </div>
          </div>
          <div class="ml-2">
            <button @click="removeStudent(index)" class="btn btn-sm btn-danger">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <!-- Informační zpráva když není vybrán typ -->
        <div v-if="!lesson.lesson_type" class="alert alert-info py-2 px-3 mb-2">
          <i class="fas fa-info-circle"></i> Nejprve vyberte typ lekce (Types of lessons) výše.
        </div>
        
        <!-- Tlačítka pro přidávání studentů -->
        <div v-if="lesson.lesson_type">
          <button 
            class="btn btn-sm btn-outline-primary mr-2" 
            @click="addStudentSlot"
            :disabled="!canAddMoreStudents"
          >
            <i class="fas fa-plus"></i> Přidat existujícího studenta
          </button>
          <button 
            class="btn btn-sm btn-outline-success" 
            @click="addNewStudentSlot"
            :disabled="!canAddMoreStudents"
          >
            <i class="fas fa-user-plus"></i> Přidat nového studenta
          </button>
          
          <!-- Zobrazení počtu přidaných studentů -->
          <div class="mt-2" v-if="lesson.students && lesson.students.length > 0">
            <small class="form-text text-muted">
              <i class="fas fa-users"></i> {{ studentCountLabel }}
            </small>
          </div>
        </div>
      </div>

    </div>
    <div class="modal-footer">
      <button @click="hideModal" type="button" class="btn btn-outline-dark">Zrušit</button>
      <button @click="sendData" class="btn btn-success">
        Uložit změny
      </button>
    </div>
  </vue-final-modal>
</template>

<style>
/* DŮLEŽITÉ: Globální styly pro v-select dropdown */
.v-select .vs__dropdown-menu {
  z-index: 99999 !important;
  max-height: 300px !important;
}

/* Když je appendToBody true, dropdown je v body, tak stačí vysoký z-index */
body > .vs__dropdown-menu {
  z-index: 99999 !important;
}

/* Disabled select styling */
select:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Info alert styling */
.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
  border-radius: 4px;
  font-size: 0.9rem;
}

/* Disabled button styling */
button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

/* Text danger for locked message */
.text-danger {
  color: #dc3545 !important;
}

/* Preferred time checkboxes - always visible, compact */
.preferred-time-checkboxes {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0.5rem 0.75rem;
  background-color: #f8f9fa;
}

.preferred-time-item {
  margin-bottom: 0.25rem;
}

.preferred-time-item:last-child {
  margin-bottom: 0;
}

.preferred-time-item label {
  cursor: pointer;
  margin: 0;
  font-weight: normal;
  font-size: 0.9rem;
}

.preferred-time-item input[type="checkbox"] {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>